import { CancelledOffers_rows } from "_graphql/visal/queries/__generated__/CancelledOffers";
import clsx from "clsx";
import { Show } from "components";
import numeral from "numeral";
import { TableData, TColumn } from "utils/types";

export const cancelledOffersColumns: TableData<TColumn<CancelledOffers_rows>> =
  [
    {
      name: "Policy #",
      accessor: "0.policy_number",
      render: (value) => (
        <div className="flex flex-col items-start flex-wrap break-all break-words">
          <div className="flex flex-row items-center gap-x-1">
            <span className="font-bold text-xs overflow-hidden text-ellipsis  ">
              {value.offer_detail_with_deleted?.policy_number || "N/A"}
            </span>
          </div>
          <div
            className={clsx(
              "p-0.5 rounded-full",
              {
                " text-green-600": value.offer_from === "INTERNAL",
                " text-yellow-600": value.offer_from !== "INTERNAL",
              },
              "text-xs font-medium"
            )}
          >
            <span>{value.offer_from}</span>
          </div>
        </div>
      ),
    },
    {
      name: "Insurance Company",
      accessor: "insurer.insurer_company_name",
      render: (value) => (
        <div className="flex flex-col text-xs">
          <span className="font-medium">
            {value.insurer?.insurer_company_name || "N/A"}
          </span>
          <span className="font-light">
            {value.insurer?.insurer_company_email || "N/A"}
          </span>
        </div>
      ),
    },
    {
      name: "Insured",
      accessor: "offer_detail.insured_by",
      render: (value) => {
        const details = JSON.parse(
          value?.offer_detail_with_deleted?.offer_details || "[]"
        );
        return (
          <div className="flex flex-col text-xs ">
            <span className="font-medium">
              {value.offer_detail_with_deleted?.insured_by || "N/A"}
            </span>
            <span className="font-light">
              {[
                "Motor Comprehensive Fleet",
                "Motor Comprehensive",
                "Motor Comprehensive (Automobile Fac Facility)",
              ].includes(value?.classofbusiness?.business_name || "")
                ? details?.find(
                    (el: { [x: string]: string }) =>
                      el?.["keydetail"] === "Vehicle Reg No" ||
                      el?.["keydetail"] === "Vehicle Reg No."
                  )?.value
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      name: "Class Of Business",
      accessor: "classofbusiness.business_name",
      render: (value) => (
        <div className="flex flex-col text-xs">
          <span className="font-medium">
            {value.classofbusiness?.business_name || "N/A"}
          </span>
        </div>
      ),
    },
    {
      name: "Sum Insured",
      accessor: "sum_insured",
      render: (value) => (
        <div className="flex flex-col text-xs">
          <span className="font-medium">
            {value?.offer_detail_with_deleted?.currency}{" "}
            {numeral(value.sum_insured).format("0,0 ") || "N/A"}
          </span>
        </div>
      ),
    },
    {
      name: "Rate",
      accessor: "rate",
    },
    {
      name: "Status",
      accessor: "offer_status",
      render: ({ offer_status }) => (
        <span
          className={clsx("text-xs font-bold", {
            "text-blue-600": offer_status === "OPEN",
            "text-yellow-600": offer_status === "PENDING",
            "text-green-600": offer_status === "CLOSED",
          })}
        >
          {offer_status}
        </span>
      ),
    },
    {
      name: "Offer Date",
      accessor: "created_at",
      render: (value) => (
        <span>{new Date(value.created_at).toLocaleDateString()}</span>
      ),
    },
    {
      name: "Created By",
      accessor: "employee.employee_first_name",
      render: (value) => (
        <div className="flex flex-row leading-0">
          <Show if={value?.offer_from === "INTERNAL"}>
            <span>
              {value?.employee?.employee_first_name}{" "}
              {value?.employee?.employee_last_name}
            </span>
          </Show>
          <Show if={value?.offer_from !== "INTERNAL"}>
            <span>{value?.place_it_created_by || "N/A"}</span>
          </Show>
        </div>
      ),
    },
  ];
